let INFO = [
  {
    title: '<b>Tablice demonstracyjne</b>',
    index: [
      '• Szkoła (Ilustracje: Dariusz Owczarek)',
      '• Zasady przechodzenia przez jezdnię ( Ilustracje: Daniel Rudnicki)',
      '• Drzewa, ich liście i owoce (Zdjęcia: BE&W, East News, Shutterstock)',
      '• Prace w ogródku – warzywa  (Ilustracje: Anna Nowocińska-Kwiatkowska, zdjęcia: BE&W, East News, Shutterstock)',
      '• Obowiązki dyżurnego (Ilustracje: Anna Nowocińska-Kwiatkowska)',
      '• Ilustracje do <i>Legendy o smoku wawelskim</i>  (Ilustracje: Małgorzata Grębowicz)',
      '• Polskie miasta i krajobrazy (Zdjęcia: BE&W, East News, Shutterstock)',
      '• Ilustracje do legendy <i>Dar rzeki Wisły</i> (Ilustracje: Magdalena Pilch)',
      '• Stoisko z napojami  (Opracowanie graficzne Katarzyna Jurgielewicz, zdjęcia Shutterstock: stół – stragan (Vectorpocket), słoiki (VitaminCo))',
    ],
  },
  {
    line: true,
    title: 'Autorki',
    index: ['<i>Karina Mucha, Anna Stalmach-Tkacz, Joanna Wosianek</i>'],
  },
  {
    line: true,
    title: 'Opracowanie redakcyjne',
    index: ['<i>Ewa Dulemba, Marzena Czarnowska-Mazurek</i>'],
  },
];

export default INFO;
